function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#export-icn_svg__clip-84F151F1-F1B2-41CB-9772-B09F4367BD34)"
}, React.createElement("path", {
  fill: "#babecd",
  d: "M15.813 11.47v5.644H2.874v-12.8h4.313V1.47h-5.75A1.43 1.43 0 000 2.892v15.645a1.43 1.43 0 001.438 1.422H17.25a1.43 1.43 0 001.438-1.422V11.47z"
}), React.createElement("path", {
  fill: "#babecd",
  d: "M22.712 4.449L16.962.182a.721.721 0 00-1.15.57v2.133h-2.156c-4.36 0-7.906 3.508-7.906 7.822a.714.714 0 00.719.71.72.72 0 00.642-.392l.17-.334c1.102-2.183 3.32-3.54 5.786-3.54h2.745v2.134c0 .268.154.514.397.635a.723.723 0 00.754-.067l5.75-4.266a.708.708 0 000-1.138z"
}));

var SvgExportIcn = function SvgExportIcn(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20"
  }, props), _ref);
};

export default SvgExportIcn;